import { Action } from 'redux';
import { User } from 'domain/User';
import DomainObjectView from 'domain/DomainObjectView';
import { Map } from 'immutable';
/* eslint-disable no-shadow, no-unused-vars */

export enum ActionType {
  ADD_USER = 'ADD_USER',
  REMOVE_USER = 'REMOVE_USER',
  UPDATE_USER = 'UPDATE_USER',
  REFRESH_USER_LIST = 'REFRESH_USER_LIST',
  SET_USER_LIST_LOADING = 'SET_USER_LIST_LOADING'
}

export interface SetUserListLoadingAction extends Action<ActionType.SET_USER_LIST_LOADING> {
  readonly isLoading: boolean;
}

export interface AddUserAction extends Action<ActionType.ADD_USER> {
  readonly user: User;
}

export interface RemoveUserAction extends Action<ActionType.REMOVE_USER> {
  readonly user: User;
}

export interface UpdateUserAction extends Action<ActionType.UPDATE_USER> {
  readonly user: User;
}

export interface RefreshUserListAction extends Action<ActionType.REFRESH_USER_LIST> {
  readonly userList: User[];
}

export type UserAction = SetUserListLoadingAction | AddUserAction | RemoveUserAction |
UpdateUserAction | RefreshUserListAction;

export interface UserList {
  readonly isLoading: boolean;
  readonly userMapById: Map<number, DomainObjectView<User>>;
}
